"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8074],{

/***/ 98074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CookieSettings": function() { return /* binding */ CookieSettings; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77480);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83168);
/* harmony import */ var hooks_useCookieSettings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34457);
/* harmony import */ var ui_components_FooterLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46502);






var CookieSettings = function(param) {
    var linkStyle = param.linkStyle;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__/* .useTranslate */ .qM)();
    var setShowCookieSettings = (0,hooks_useCookieSettings__WEBPACK_IMPORTED_MODULE_4__/* .useCookieSettings */ .eK)().setShowCookieSettings;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            role: "none",
            className: "flex",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_FooterLink__WEBPACK_IMPORTED_MODULE_5__/* .FooterLink */ .S, {
                "data-test-id": "cookie-settings-link",
                role: "menuitem",
                href: "#",
                linkStyle: linkStyle,
                onClick: function(clickEvent) {
                    clickEvent.preventDefault();
                    setShowCookieSettings(true);
                    (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .footerNavigationClickEvent */ .i7)("Support:Cookie settings");
                    (0,utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_3__/* .AnalyticsEvents.FOOTER_LINK_CLICKED */ ._q.FOOTER_LINK_CLICKED, {
                        domevent: t("cookieSettings").toLowerCase()
                    });
                },
                children: t("cookieSettings")
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CookieSettings);


/***/ })

}]);